module.exports = __webpack_public_path__ + "img/feature-03-battle.b5af615e.svg";